module.exports = __webpack_public_path__ + "img/keyboard_W.dd2c3623.png";